import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import globaltypes from '../../store/globaltypes'
import productinfo from '../productinfo'

export default {
  name: 'infoline',
  components: { productinfo },
  props: {
    label: String,
    content: [String, Array, Object],
    horizontalList: Boolean,
    verticalList: Boolean,
    link: String,
    grouped: Boolean,
    expandable: Boolean,
    action: Function
  },
  data () {
    return {
      showMoreVarieties: false,
      linesToShow: 5
    }
  },
  computed: {
    ...mapGetters({
      crop: globaltypes.crops.getters.crop
    }),
    singleShowMore () {
      return single => (single.showMore || false)
    },
    hasContent () {
      if (!this.grouped && (this.horizontalList || this.verticalList)) return this.content.length
      if (this.grouped && (this.horizontalList || this.verticalList)) return !!this.content
      if (!this.content) return !!this.$slots.default
      return true
    }
  },
  methods: {
    ...mapActions({
      inform: globaltypes.main.actions.setInformation
    }),
    moreinfo (key) {
      this.inform(`Binnekort toon ik hier meer info over artikel ${key}`)
    },
    toggle (single) {
      Vue.set(single, 'showMore', !single.showMore)
      this.$forceUpdate()
    }
  }
}
